import {  gql } from '@apollo/client';

export const GET_WALLPAPERS = gql`
query {
  getWallpapers {
  id
  image
  title
  category
  description
  username
}
 }
`;


export const GET_WALLPAPER = gql`
query($wallpaperId: ID!) {
getWallpaper(wallpaperId: $wallpaperId) {
 id
 image
 title
 category
 description
 username
}
}
`;


export const SEARCH_WALLPAPERS = gql`
   
  query searchWallpapers($search: String) {
    searchWallpapers(search: $search) {
      image
      title
      category
      description
    }
  }
`